import { render, staticRenderFns } from "./SimulationInteraction.vue?vue&type=template&id=378a00e3&scoped=true"
import script from "./SimulationInteraction.vue?vue&type=script&lang=js"
export * from "./SimulationInteraction.vue?vue&type=script&lang=js"
import style0 from "./SimulationInteraction.vue?vue&type=style&index=0&id=378a00e3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378a00e3",
  null
  
)

export default component.exports